module.exports = __webpack_public_path__ + "img/spirit_light_brown_ba_list.9ae7b589.jpg";